// Global Instructions Rule Applied!
//
// The slugs the in-app help drawer asks for — one entry per guide the app has.
//
// Why a registry rather than a literal at each call site: a screen wired to a
// slug nobody seeded fails SILENTLY. HelpButton renders nothing for an unset
// key, and HelpArticleBody renders "No guide has been written for this screen
// yet" for a key that resolves to nothing — both deliberate, so that a guide
// can be written after the screen ships. The cost is that a typo, or a rename
// on the migration side, looks exactly like a screen whose guide is not
// written yet. Collecting the keys here gives helpArticles.test.ts one list to
// check against the seed migrations, which is the only place the two halves of
// that contract meet.
//
// A key is added here in the same commit as the migration that seeds it. The
// value is cfg.help_articles.article_key: '<module>.<surface>', never a
// cfg.menu_items id (a screen can have two menu rows — see
// 20260927120000_help_articles_schema.sql).

export const HELP_ARTICLES = {
  /** Connected Agents → Connected agents tab. Seeded by 20260927120100. */
  connectedAgents: 'agent_access.my_agents',
  /**
   * Agent drafts — My Drafts and the account / prospect Relationship tab
   * point at the same guide, because they show the same cards. Seeded by
   * 20261105150000.
   */
  agentDrafts: 'agent_drafts.my_drafts'
} as const

export type HelpArticleKey = (typeof HELP_ARTICLES)[keyof typeof HELP_ARTICLES]
